import React, { useState, useEffect } from "react";
import { useAppSelector } from "../../hooks/useAppStore";
import { selectSettings } from "../../store/slices/settingsSlice";

const TYPE_STYLES = {
  info: {
    border: "border-blue-500/30",
    bg: "bg-blue-500/10",
    title: "text-blue-400",
  },
  warning: {
    border: "border-yellow/30",
    bg: "bg-yellow/10",
    title: "text-yellow",
  },
  success: {
    border: "border-green-500/30",
    bg: "bg-green-500/10",
    title: "text-green-400",
  },
  promo: {
    border: "border-magenta/30",
    bg: "bg-magenta/10",
    title: "text-magenta",
  },
};

export const PopupNotification: React.FC = () => {
  const settings = useAppSelector(selectSettings);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (settings?.popupActive && settings.popupMessage) {
      // Small delay so it doesn't flash on initial load
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, [settings?.popupActive, settings?.popupMessage]);

  if (!visible || !settings?.popupActive || !settings.popupMessage) return null;

  const type = settings.popupType ?? "info";
  const styles = TYPE_STYLES[type] ?? TYPE_STYLES.info;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm px-4">
      <div
        className={`w-full max-w-sm bg-[#1a1818] border ${styles.border} ${styles.bg} rounded-2xl p-6 shadow-2xl`}
      >
        {settings.popupTitle && (
          <h3 className={`font-display font-bold text-lg mb-2 ${styles.title}`}>
            {settings.popupTitle}
          </h3>
        )}
        <p className="text-offwhite/80 text-sm font-semibold leading-relaxed">
          {settings.popupMessage}
        </p>
        <button
          onClick={() => setVisible(false)}
          className="mt-5 w-full py-2.5 rounded-xl bg-white/10 hover:bg-white/15 text-offwhite text-sm font-medium transition-colors"
        >
          Got it
        </button>
      </div>
    </div>
  );
};
